
import React, { useEffect, useState } from 'react';
import { CCard, CCardBody, CCardHeader, CCol, CRow, CButton, CAccordion, CAccordionItem, CAccordionBody, CAccordionHeader } from '@coreui/react';
import { DataGrid } from '@mui/x-data-grid';
import { Link, useLoaderData, useLocation, useNavigate } from 'react-router-dom';
import { confirmAlert } from 'react-confirm-alert';
import AxiosInstance from 'src/components/Axios';
import { cilPen, cilPlus, cilTrash } from '@coreui/icons';
import CIcon from '@coreui/icons-react';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import MyToastify from 'src/components/myComponents/MyToactify';
import dayjs from 'dayjs';
import Select from 'react-select';


const page = 1
const urlApi = '/subpoenas'
const urlApi1 = '/subpoenasItems'
const urlRouter = '/directives'
const id = 47105;


// хто увійшов
const role = localStorage.getItem('user_role')
// дані користувача
const userData = JSON.parse(localStorage.getItem('user_data'))



export async function LoaderMyDirectives({ params }) {

   let query = `page=${page}`

   if (role === 'ROLE_PARTNER') query += `&account.user.id=${userData.id}`

   let data = await AxiosInstance.get(`${urlApi}?${query}`


   ).then((response) => {
      console.log("get /api/subpoenas/ response", response.data['hydra:member']);
      return response

   });
   return data;

}

// const navItems = _nav_admin(data.length);

export default function MyDirectives() {
   const { data } = useLoaderData()
   const { state } = useLocation();
   const navigate = useNavigate();
   console.log('state', state)
   // console.log('account_id', JSON.parse(localStorage.getItem('user_data')).id)
   console.log('data', data)

   // const subpoenasItems = []
   // data['hydra:member'].forEach(elem => {
   //    subpoenasItems.push(...elem.subpoenaItems)
   // })


   //Попередня підготовка
   const [rows, setRows] = useState([]);
   const [rowCountState, setRowCountState] = useState(0);
   // Викликає popup з власного компонента
   const popup = MyToastify();
   // Текст для popup
   const popupTextSuccess = "Припис видалено";
   //стейти для селекта з контрагентами
   const [selectedOption, setSelectedOption] = useState('')
   const [options, setOptions] = useState([])
   const [synkStatus, setSynkStatus] = (state?.synkStatus ? state.synkStatus : '')
   // стейти для селекта зі статусами
   // Список можливих статусів
   const possibleStatuses = [
      { value: 'new', label: 'Не перевірено' },
      { value: 'send_to_verify', label: 'Відправлено на перевірку' },
      { value: 'verified', label: 'Перевірено' },
      { value: 'synced', label: 'Завантажено в 1С' },
   ];
   const [statusFilterSearch, setStatusFilterSearch] = useState('')
   const [statusOptions, setStatusOptions] = useState(possibleStatuses)


   // Заблокувати кнопку фільрації якщо не введені символи для пошуку
   const [isDisabled, setIsDisabled] = useState(true)

   // Якщо лінк відбувся з головної сторінки по "send_to_verify", то віддразу відфільтрувати
   useEffect(() => {
      // console.log('state', state);
      // console.log("фільтр по статус");
      if (state?.synkStatus === "send_to_verify") {
         console.log('synkStatus', state.synkStatus)
         setStatusFilterSearch({ value: 'send_to_verify', label: 'Відправлено на перевірку' });
         // Задати значення "Статус" в фільтрі для коректного відображення активного фільтра
         // setStatusFilterSearch({ value: 'not_checked', label: 'Не перевірено' });
         AxiosInstance.get(`${urlApi}?subpoenaItems.synkStatus=${state.synkStatus}`).then((response) => {
            setRows(response.data['hydra:member']);
            setRowCountState(response.data['hydra:totalItems']);
            setOptions(response.data['hydra:member'].map(elem => {
               return ({
                  value: elem.account.id,
                  label: elem.account.name
               })
            })
               .filter((option, index, self) =>
                  index === self.findIndex(o => o.value === option.value))
            )
            if (state) {
               navigate(location.pathname, { replace: true, state: null });
            }

         });
      }
      else {

         const subpoenas = data['hydra:member']

         if (rows.length === 0) {
            setRowCountState(subpoenas.length)
            setRows(subpoenas);
         }
         setOptions(data['hydra:member'].map(elem => {
            return ({
               value: elem.account.id,
               label: elem.account.name
            })
         })
            .filter((option, index, self) =>
               index === self.findIndex(o => o.value === option.value))

         )
      }
   }, []);

   // useEffect(() => {
   //    const subpoenas = data['hydra:member']

   //    if (rows.length === 0) {
   //       setRowCountState(subpoenas.length)
   //       setRows(subpoenas);
   //    }
   //    setOptions(data['hydra:member'].map(elem => {
   //       return ({
   //          value: elem.account.id,
   //          label: elem.account.name
   //       })
   //    }))
   // }, [])



   //нова логіка
   // useEffect(() => {
   //    const subpoenas = data['hydra:member']

   //    if (rows.length === 0) {
   //       setRowCountState(subpoenas.length)
   //       setRows(subpoenas);
   //    }
   //    setOptions(data['hydra:member'].map(elem => {
   //       return ({
   //          value: elem.account.id,
   //          label: elem.account.name
   //       })
   //    }))
   //    console.log('subpoenas', subpoenas)
   // }, [])



   const getRowsTable = (p = 1) => {

      let request = `page=${page}`

      if (role === 'ROLE_PARTNER') request += `&account.user.id=${userData.id}`

      if (selectedOption !== '') {
         request += `&account=/api/accounts/${selectedOption.value}`
      }
      if (statusFilterSearch !== '') request += `&subpoenaItems.synkStatus=${statusFilterSearch.value}`

      // AxiosInstance.get(`${urlApi}?page=${p}`).then((response) => {
      AxiosInstance.get(`${urlApi}?${request}`).then((response) => {
         console.log('response', response)
         const items = response.data['hydra:member']
         setRows(items)
         setRowCountState(items.length)
         // setRows(response.data['hydra:member']);
         setOptions(response.data['hydra:member'].map(elem => {
            return ({
               value: elem.account.id,
               label: elem.account.name
            })
         })
            .filter((option, index, self) =>
               index === self.findIndex(o => o.value === option.value))
         )
      });
   };
   const handlePageChange = (page) => {
      getRowsTable(page + 1);
   }

   // function Deleted(row) {
   //    confirmAlert({
   //       title: 'Ви впевнені що хочите видалити цей пункт ?',
   //       message: 'Are you sure to do this.',
   //       buttons: [
   //          {
   //             label: 'Так',
   //             onClick: () => {
   //                const response = AxiosInstance.delete(`${urlApi}/${row.id}`).then((response) => {
   //                   // Popup про успішні зміни
   //                   popup.toastifySuccess(popupTextSuccess);
   //                   getRowsTable();
   //                });
   //             }
   //          },
   //          {
   //             label: 'Ні',
   //             onClick: () => {
   //                return;
   //             }
   //          }
   //       ]
   //    });
   // };

   // console.log("params", params);

   const columns = [
      {
         field: 'code',
         headerName: 'Код',
         width: 150,
         align: 'center',
         headerAlign: 'center'
      },
      // { field: 'description', headerName: 'Опис', width: 300 },
      {
         field: 'accountName',
         headerName: 'Контрагент',
         width: 200,
         valueGetter: (params) => params.row.account?.name || '',
         align: 'center',
         headerAlign: 'center'
      },
      {
         field: 'dateCreate',
         headerName: 'Дата створення',
         width: 200,
         renderCell: (params) => {

            return <span>{dayjs(params.row.date).local().
               format('DD.MM.YYYY')
               // format('DD.MM.YYYY HH:mm')
            }</span>
         },
         align: 'center',
         headerAlign: 'center'
      },
      // {
      //    field: 'synkStatus',
      //    headerName: 'Статус',
      //    width: 200,
      //    align: 'center',
      //    headerAlign: 'center'
      // },
      // {
      //    field: 'synkStatus',
      //    headerName: 'Статус',
      //    width: 200,
      //    align: 'center',
      //    headerAlign: 'center',
      //    renderCell: (params) => {
      //       return params.row?.subpoenaItems?.find(elem => elem.synkStatus === statusFilterSearch) || null;
      //    }
      // },

      // { field: 'top', headerName: 'top', width: 100 },
      {
         field: "action",
         headerName: "Action",
         sortable: false,
         width: 70,
         renderCell: (params) => {
            return <Link to={`${urlRouter}/update/${params.row.id}`}><CButton color="dark" variant="outline"><CIcon icon={cilPen} customClassName="nav-icon" height={20} /></CButton></Link>;
         }
      },

   ];

   //(верх) Попередня підготовка


   //логіка для фільтру

   // Фільтрування
   const handleFilterSearch = () => {
      // setSynkStatus(statusFilterSearch)
      getRowsTable()
   }

   // Скинути фільтр
   const handleFilterReset = () => {
      setSelectedOption('')
      setStatusFilterSearch('')
      //  setDisabled(true)
      // setSynkStatus('')
      getRowsTable()
   }

   // const disabledButton = () => {
   //    if (selectedOption === '') {
   //       setDisabled(true)
   //    }

   // }

   useEffect(() => {
      // Розблокувати кнопку, якщо хоча б одне поле містить значення
      if (selectedOption || statusFilterSearch) {
         setIsDisabled(false)
      }
      else {
         setIsDisabled(true)
      }
   }, [selectedOption, statusFilterSearch])


   // useEffect(() => {

   //    if (state) {
   //       navigate(location.pathname, { replace: true, state: null });
   //    }
   // }, []);

   // console.log('rows', rows)
   // console.log('options', options)
   // console.log('selectedOption', selectedOption)
   // console.log('statusOptions', statusOptions)
   // console.log('statusFilter', statusFilterSearch)
   return (

      <>
         <h1>Мої приписи</h1>
         {/* Popup про успішні зміни (справа зверху) */}
         <ToastContainer />

         <CRow>
            <CCol xs={12}>
               <CCard className="mb-4">
                  {/* місце для фільтру */}
                  <CAccordion flush>
                     <CAccordionItem>
                        <CAccordionHeader>
                           <strong>Фільтр</strong>
                        </CAccordionHeader>
                        <CAccordionBody>
                           <CRow className="my-3 mx-2">
                              <CCol md={9} className="me-auto">
                                 <CRow>
                                    <CCol md={4} className="mt-3 filter-field">

                                       <div className="col d-flex justify-content-start">
                                          <Select
                                             options={statusOptions}
                                             value={statusFilterSearch}
                                             onChange={(option) => setStatusFilterSearch(option)}
                                             // className="w-25"
                                             className='me-2'
                                             // isDisabled={props.isDisabledChange}
                                             placeholder="Виберіть статус"
                                          />
                                       </div>

                                    </CCol>

                                    {/* Поле фільтра по статусу */}
                                    <CCol md={4} className="mt-3 filter-field">

                                       <div className="col d-flex justify-content-start">
                                          <Select
                                             options={options}
                                             value={selectedOption}
                                             onChange={(option) => setSelectedOption(option)}
                                             // className="w-25"
                                             className='me-2'
                                             // isDisabled={props.isDisabledChange}
                                             placeholder="Виберіть контрагента"
                                          />
                                       </div>

                                    </CCol>



                                    {/* Поле фільтра по типу */}
                                 </CRow>
                              </CCol>

                              <CCol md={3} style={{ textAlign: 'end' }}>
                                 <CButton className="me-2" type="submit" color="secondary"
                                    onClick={handleFilterSearch}
                                    disabled={isDisabled}
                                 >Пошук</CButton>
                                 <CButton type="submit" color="secondary"
                                    onClick={handleFilterReset}
                                 >X</CButton>
                              </CCol>
                           </CRow>
                        </CAccordionBody>
                     </CAccordionItem>
                  </CAccordion>

                  {/* місце для фільтру */}
                  <CCardHeader>
                     <strong>Приписи</strong> <small></small>
                  </CCardHeader>
                  <CCardBody>
                     {/* <p className="text-medium-emphasis small">
                        <Link to={`${urlRouter}/create`}><CButton color="secondary"><CIcon icon={cilPlus} customClassName="nav-icon" height={15} />Створити</CButton></Link>
                     </p> */}
                     <div style={{ height: 400, width: '100%' }}>
                        <DataGrid
                           rows={rows}
                           columns={columns}
                           pageSize={30}
                           rowsPerPageOptions={[30]}
                           pagination
                           rowCount={rowCountState}
                           paginationMode="server"
                           onPageChange={handlePageChange}
                           getRowHeight={() => 'auto'}
                        // getRowWidth={() => 'auto'}
                        />
                     </div>
                  </CCardBody>
               </CCard>
            </CCol>
         </CRow>
      </>




   )
}